module.exports = __webpack_public_path__ + "static/1-1eedb931b98187f5843abad0d8790723.jpg";